const BulmaCarousel = r => require.ensure([], () => r(require('./BulmaCarousel.vue')), 'shared')
const BulmaCarouselModal = r => require.ensure([], () => r(require('./BulmaCarouselModal.vue')), 'shared')

export { BulmaCarousel, BulmaCarouselModal }
